import React from 'react';
import { NotificationsCentreState } from 'src/components/NotificationsCentre/NotificationsCentreState';
import { NotificationListItem, NotificationsList } from 'src/components/NotificationsCentre/NotificationsCentre.style';
import { ChatRequestNotification } from 'src/components/NotificationsCentre/ChatRequestNotification/ChatRequestNotification';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/AppState/Common';

export const ChatNotificationsList = observer('ChatNotificationsList', () => {
    const common = useCommon();
    const state = NotificationsCentreState.get(common);

    const notifications = state.chatNotifications;

    const pendingChatItems: Array<JSX.Element> = [];
    const ongoingChatItems: Array<JSX.Element> = [];

    notifications.forEach((notification) => {
        const status = notification.status;
        const item = (
            <ChatRequestNotification
                chatItem={notification}
                onClose={state.toggleChatList}
            />
        );

        if (status === 'pending') {
            pendingChatItems.push(
                <NotificationListItem
                    key={notification.id}
                    data-test='notifications-list-item'
                >
                    {item}
                </NotificationListItem>
            );
        } else {
            ongoingChatItems.push(
                <NotificationListItem
                    key={notification.id}
                    data-test='notifications-list-item'
                >
                    {item}
                </NotificationListItem>
            );
        }
    });

    return (
        <NotificationsList>
            {pendingChatItems}
            {ongoingChatItems}
        </NotificationsList>
    );
});
